import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sz-primary-grey--text f-24 font-weight-medium text-center mb-5" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "my-3 mx-2 d-flex justify-center"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_5 = ["href"]

import BaseButton from '@/components/widgets/BaseButton.vue';
import { LINKS } from '@/constants/externalLinks';
import { ref } from 'vue';
import type { Maybe } from '@/types';
import { useGoTo } from 'vuetify';
import type { FaqItem } from '@/types/faq.ts';

type Props = {
    faq?: FaqItem[];
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQPanels',
  props: {
    faq: { default: () => [] }
  },
  setup(__props: any) {

const goTo = useGoTo();



const panel = ref<Maybe<number>>(null);

const getQuestionId = (index: number): string => 'faq-question-' + index;

const goToQuestion = function (index: number) {
    setTimeout(() => goTo('#' + getQuestionId(index)), 250);
};


return (_ctx: any,_cache: any) => {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_orphans = _resolveDirective("orphans")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_col, {
    cols: "12",
    class: "pa-0 faq-list mb-10"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('label.faq')), 1),
      _createVNode(_component_v_expansion_panels, {
        modelValue: panel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((panel).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq, (item, index) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: index,
              class: "sz-primary-grey--text elevation-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, {
                  id: getQuestionId(index),
                  class: "font-weight-medium f-18",
                  onClick: ($event: any) => (goToQuestion(index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.header), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "onClick"]),
                _createVNode(_component_v_expansion_panel_text, { class: "f-16" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "line-height-2",
                      innerHTML: item.content
                    }, null, 8, _hoisted_2),
                    (item?.button)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(BaseButton, {
                            href: item.button?.href
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.button?.text), 1)
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ]))
                      : _createCommentVNode("", true),
                    (item?.link)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("a", {
                            target: "_blank",
                            class: "primary-link",
                            href: item.link.href
                          }, _toDisplayString(item.link.text), 9, _hoisted_5)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          justify: "center",
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                _createVNode(BaseButton, {
                  href: _unref(LINKS).guide,
                  variant: "secondary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.showGuide')), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  })), [
    [_directive_orphans]
  ])
}
}

})